module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAMAAADpVnyHAAAAM1BMVEVHcEzGLQ7/AADFLQ/FLg/GLg/GLg7YJQDFLg7FLg/GLQ/GLg7HLQzGLQ7GLgrHLQ/FLg+Lc647AAAAEHRSTlMAxgGo1OByB+21PlspkxhESAuaMwAAAIRJREFUKM91klsOxSAIBQ8+EF8t+1/t1fhxbSvzcwwTIiEAiyptPYoUPClKbmYK2l4KXusM1v6vJfZ5QCozRGmG5wS0qEfCBVIDD8tosFXcVBdLBVx9V7KrMW421dgKmQrOWyqxnJWr0fir0HlCubMaw78RRHuHbCkeV3Hsi7zu4cus/wBdKBoItNH9OgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/old_age_education/lesson-icon.png
// module id = USB0
// module chunks = 1